import script from "./Plans.vue?vue&type=script&setup=true&lang=js"
export * from "./Plans.vue?vue&type=script&setup=true&lang=js"

import "./Plans.vue?vue&type=style&index=0&id=10998a61&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-10998a61"]])

export default __exports__